// Customizable Area Start
import React from "react";
import {
  Avatar,
  Box,
  Button,
  Checkbox,
  Chip,
  Divider,
  Input,
  Pagination,
  PaginationItem,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import SearchTwoToneIcon from "@mui/icons-material/SearchTwoTone";
import CloseIcon from "@mui/icons-material/Close";
import NavigationMenu from "../../navigationmenu/src/NavigationMenu.web";
import Filters from "../../../blocks/filteritems/src/Filters.web";
import Sorting from "../../../blocks/sorting/src/Sorting.web";
import SearchTalent from "../../../blocks/advancedsearch/src/SearchTalent.web";
import FullPageLoader from "../../../components/src/FullPageLoader.web";
import ConditionalRenderer from "../../../components/src/ConditionalRenderer.web";
import AppFooter from "../../../components/src/AppFooter.web";
import BannerWithContent from "../../../components/src/BannerWithContent.web";
import CatalogueController, { Props } from "./CatalogueController";
import GoogleAd from "../../../components/src/GoogleAd.web";
const configJSON = require("./config.js");

const TypographyView = styled(Box)({
  "& *": {
    fontFamily: "Montserrat !important",
  },
  "& .catalogueListingAttr": {
    backgroundColor: "#fff",
    padding: "50px",
    marginBottom: "50px",
    borderRadius: "8px",
    "@media (max-width: 767px)": {
      padding: "20px",
      marginBottom: "20px",
    },
  },
  "& .catalogueFilterContainer": {
    marginBottom: "20px",
  },
  "& .catalogueFilterContainer h3": {
    color: "#0F172A",
  },
  "& .catalogueSortContainer": {
    marginBottom: "12px",
  },
  "& .catalogueSortContainer h2": {
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "19.5px",
    marginBottom: "15px",
    color: "#0F172A",
  },
  "& .catalogueSearchContainer": {
    marginBottom: "20px",
  },
  "& .filterAndSortTags": {
    height: "32px",
    border: "0.5px solid #94A3B8",
    borderRadius: "4px",
    backgroundColor: "#fff",
    padding: "6px 12px",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "22px",
    fontColor: "#0F172A !important",
  },
  "& .catalogueSearchContainer h2": {
    fontSize: "20px",
    fontWeight: "500",
    lineHeight: "24.38px",
    color: "#0F172A",
    margin: "0 0 14px 0",
    "@media (max-width: 414px)": {
      fontSize: "16px",
      lineHeight: "20px",
    },
    "@media (min-width: 415px) and (max-width: 1280px)": {
      fontSize: "18px",
      lineHeight: "22px",
    },
    "@media (min-width: 1600px)": {
      fontSize: "22px",
      lineHeight: "26px",
    },
  },
  "& .catalogueSearchInputs": {
    display: "flex",
    gap: "50px",
    "@media (max-width: 767px)": {
      flexDirection: "column",
      gap: "20px",
    },
  },
  "& .catalogueSearchInput": {
    position: "relative",
    width: "88%",
    "@media (max-width: 767px)": {
      width: "100%",
    },
  },
  "& .catalogueSearchInput > div": {
    width: "100%",
    border: "1px solid #CBD5E1",
    borderRadius: "8px",
    "& svg": {
      position: "absolute",
    },
    "& input": {
      padding: "12px 16px 12px 48px",
      fontSize: "16px",
      fontWeight: "500",
      lineHeight: "19.5px",
      color: "#64748B",
      letterSpacing: "-0.15px",
      "@media (max-width: 414px)": {
        fontSize: "12px",
        lineHeight: "15px",
      },
      "@media (min-width: 415px) and (max-width: 1280px)": {
        fontSize: "14px",
        lineHeight: "17px",
      },
      "@media (min-width: 1600px)": {
        fontSize: "18px",
        lineHeight: "21px",
      },
      "&::placeholder": {
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "19.5px",
        color: "#64748B",
        opacity: "1 !important",
        "@media (max-width: 414px)": {
          fontSize: "12px",
          lineHeight: "15px",
        },
        "@media (min-width: 415px) and (max-width: 1280px)": {
          fontSize: "14px",
          lineHeight: "17px",
        },
        "@media (min-width: 1600px)": {
          fontSize: "18px",
          lineHeight: "21px",
        },
      },
    },
    "&:before, &:after": {
      border: "none !important",
    },
  },
  "& .catalogueCheckboxInput": {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },
  "& .catalogueCheckboxInput div": {
    "&:before, &:after": {
      border: "none !important",
    },
  },
  "& .catalogueCheckboxInput p": {
    fontSize: "14px",
    lineHeight: "24px",
    color: "#0F172A",
    margin: "0",
    fontWeight: "500",
    whiteSpace: "nowrap",
    "@media (min-width: 1600px)": {
      fontSize: "16px",
      lineHeight: "26px",
    },
  },
  "& .catalogueHireContainer": {
    display: "flex",
    flexDirection: "column",
  },
  "& .catalogueHireTitle": {
    fontSize: "32px",
    fontWeight: "600",
    lineHeight: "39.01px",
    color: "#0F172A",
    margin: "0 0 42px 0",
    alignSelf: "center",
    "@media (max-width: 414px)": {
      fontSize: "28px",
      lineHeight: "35px",
    },
    "@media (min-width: 415px) and (max-width: 1280px)": {
      fontSize: "30px",
      lineHeight: "37px",
    },
    "@media (min-width: 1600px)": {
      fontSize: "34px",
      lineHeight: "42px",
    },
    "@media (max-width: 767px)": {
      margin: "0 0 20px 0",
    },
  },
  "& .catalogueHireCards": {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: "20px",
    marginBottom: "40px",
    "@media (max-width: 767px)": {
      gridTemplateColumns: "repeat(1, 1fr)",
    },
    "@media (min-width: 768px) and (max-width: 860px)": {
      gridTemplateColumns: "repeat(2, 1fr)",
    },
    "@media (min-width: 861px) and (max-width: 1124px)": {
      gridTemplateColumns: "repeat(3, 1fr)",
    },
    "@media (min-width: 1400px) and (max-width: 1800px)": {
      gridTemplateColumns: "repeat(5, 1fr)",
    },
    "@media (min-width: 1800px)": {
      gridTemplateColumns: "repeat(6, 1fr)",
    },
  },
  "& .catalogueHireCard": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "#fff",
    borderRadius: "12px",
    boxShadow: "0px 4px 8px 0px #00000008, 0px 8px 32px 0px #0000000F",
    padding: "30px",
    overflow: "hidden",
  },
  "& .catalogueCardImg": {
    overflow: "hidden",
    height: "102px",
    width: "102px",
    borderRadius: "50%",
    marginBottom: "8px",
  },
  "& .catalogueHireCard h2": {
    fontSize: "20px",
    fontWeight: "500",
    lineHeight: "35.51px",
    margin: "0",
    "@media (max-width: 414px)": {
      fontSize: "16px",
      lineHeight: "31px",
    },
    "@media (min-width: 415px) and (max-width: 1280px)": {
      fontSize: "18px",
      lineHeight: "33px",
    },
    "@media (min-width: 1600px)": {
      fontSize: "22px",
      lineHeight: "38px",
    },
  },
  "& .artistNameText": {
    fontSize: "20px",
    fontWeight: "500",
    lineHeight: "35.31px",
    color: "#000000",
    margin: "8px 0px",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    width: "100%",
    textAlign: "center",
  },
  "& .catalogueHireCard p": {
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "17.07px",
    color: "#64748B",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    width: "100%",
    textAlign: "center",
    "@media (max-width: 414px)": {
      fontSize: "10px",
      lineHeight: "13px",
    },
    "@media (min-width: 415px) and (max-width: 1280px)": {
      fontSize: "12px",
      lineHeight: "15px",
    },
    "@media (min-width: 1600px)": {
      fontSize: "16px",
      lineHeight: "19px",
    },
  },
  "& .catalogueCardButtons": {
    display: "flex",
    justifyContent: "center",
    gap: "10px",
    width: "100%",
  },
  "& .catalogueCardProfileButton": {
    fontSize: "10px",
    fontWeight: 600,
    color: "#fff",
    lineHeight: "24px",
    border: "1px solid currentColor",
    borderRadius: "30px",
    padding: "5px 0",
    background: "linear-gradient(90deg, #8077FF 0%, #652784 60%)",
    textTransform: "none",
    position: "relative",
    flex: 1,
    zIndex: 1,
    "&::before": {
      content: '""',
      position: "absolute",
      top: "-1px",
      left: "-1px",
      right: "-1px",
      bottom: "-1px",
      zIndex: -1,
      borderRadius: "30px",
      background: "linear-gradient(90deg, #8077FF 0%, #652784 60%)",
    },
  },
  "& .catalogueCardMessageButton": {
    fontSize: "10px",
    fontWeight: 600,
    color: "#652784",
    lineHeight: "24px",
    border: "1px solid #652784",
    borderRadius: "30px",
    padding: "4px 0",
    background: "#fff",
    textTransform: "none",
    flex: 1,
  },
  "& .customPagination": {
    alignSelf: "center",
  },
  "& .MuiPaginationItem-previousNext": {
    fontSize: "12px",
    lineHeight: "15px",
    border: "0 !important",
    padding: "10px",
    "@media (max-width: 1280px)": {
      fontSize: "10px",
      lineHeight: "13px",
    },
    "@media (min-width: 1600px)": {
      fontSize: "14px",
      lineHeight: "17px",
    },
  },
});

const EmptyResultTitle = styled(Typography)({
  color: "#0F172A",
  fontSize: "2rem",
  fontWeight: 500,
  textAlign: "center",
  whiteSpace: "pre-line",
  lineHeight: "48px",
});

const EmptyResultSubTitle = styled(Typography)({
  color: "#64748B",
  fontSize: "1.25rem",
  fontWeight: 500,
  textAlign: "center",
  whiteSpace: "pre-line",
  lineHeight: "30px",
});
// Customizable Area End

export default class Catalogue extends CatalogueController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start
  // Customizable Area End

  render() {
    const { isLoading, bannerImage, bannerHeading, bannerDescription } =
      this.state;

    return (
      //Merge Engine DefaultContainer
      // Customizable Area Start
      <>
        <TypographyView>
          <NavigationMenu navigation={this.props.navigation} id={""} />
          <FullPageLoader isLoading={isLoading} />
          <BannerWithContent
            overlay
            backgroundImage={bannerImage}
            title={bannerHeading}
            description={bannerDescription}
          >
            <Box className="catalogueListingAttr">
              <Box className="catalogueSearchContainer">
                <Box component={"h2"}>Search Talent:</Box>
                <Box className="catalogueSearchInputs">
                  <Box className="catalogueSearchInput">
                    <Input
                      autoComplete="off"
                      ref={this.searchFieldRef}
                      value={this.state.searchValue}
                      data-test-id="searchField"
                      onChange={this.handleSearchValueChange}
                      type="search"
                      placeholder="Name, Skills, or keywords"
                      endAdornment={this.getSearchLoader()}
                    />
                    <SearchTwoToneIcon
                      sx={{
                        position: "absolute",
                        left: "16px",
                        top: "12px",
                        width: "24px",
                        height: "24px",
                        fill: "#94A3B8",
                      }}
                    />
                    <SearchTalent
                      data-test-id="searchTalent"
                      id="searchTalent"
                      talentList={this.state.searchUsersList}
                      searchPopupId="chat-search-popup"
                      anchorEl={this.state.anchorEl}
                      open={
                        !this.state.isSearching && Boolean(this.state.anchorEl)
                      }
                      onClose={this.handleSearchPopupClose}
                      onResultClick={this.handleProfileRedirect}
                    />
                  </Box>
                  <Box
                    data-test-id="showFilters"
                    className="catalogueCheckboxInput"
                    onClick={this.handleShowFilterChange}
                  >
                    <Checkbox
                      icon={<this.CustomUncheckedIcon />}
                      checkedIcon={<this.CustomCheckedIcon />}
                      checked={this.state.showFilters}
                    />
                    <Typography>Show Filters</Typography>
                  </Box>
                </Box>
              </Box>
              {this.state.showFilters && (
                <>
                  <Box
                    data-test-id="filters"
                    className="catalogueFilterContainer"
                  >
                    <Filters
                      id="catalogueFilters"
                      data-test-id="catalogue-filters"
                      filtersList={this.state.filterAndSortTags}
                      handleFilterChange={this.handleFilterChange}
                    />
                  </Box>
                  <Box className="catalogueSortContainer">
                    <Typography variant="h2">Sort:</Typography>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        flexWrap: "wrap",
                      }}
                    >
                      <Sorting
                        data-test-id="sortBtns"
                        handleSortChange={this.handleSortChange}
                        navigation={this.props.navigation}
                        id="sorting"
                      />
                      <Button
                        variant="outlined"
                        data-test-id="clearAllBtn"
                        onClick={this.handleClearAll}
                        sx={{
                          width: "100px",
                          height: "44px",
                          border: "1px solid #652784",
                          borderRadius: "30px",
                          textTransform: "none",
                        }}
                      >
                        Clear All
                      </Button>
                    </Box>
                  </Box>
                  <Box>
                    <Divider sx={{ margin: "30px 0px" }} />
                  </Box>
                  <Box mt={2} display="flex" flexWrap="wrap" gap={1}>
                    {this.state.filterAndSortTags.map((tag) => (
                      <Chip
                        key={tag.type}
                        data-test-id={tag.type}
                        label={
                          <Box
                            sx={{ color: "#0F172A !important" }}
                            component="span"
                          >
                            {this.renderTagLabel(tag)}
                          </Box>
                        }
                        deleteIcon={
                          <CloseIcon sx={{ color: "#0F172A !important" }} />
                        }
                        onDelete={() => this.handleRemoveTag(tag)}
                        className="filterAndSortTags"
                      />
                    ))}
                  </Box>
                </>
              )}
            </Box>
            <Box className="catalogueHireContainer">
              {this.state.usersList.length > 0 ? (
                <>
                  <Box component={"h2"} className="catalogueHireTitle">
                    Find Talent for Hire
                  </Box>
                  <Box className="catalogueHireCards">
                    {this.state.usersList.map((userDetails) => {
                      const {
                        id,
                        attributes: {
                          full_name,
                          roles,
                          user_image_url,
                          locations,
                        },
                      } = userDetails;
                      return (
                        <Box className="catalogueHireCard" key={id}>
                          <Box className="catalogueCardImg">
                            <Avatar
                              src={user_image_url}
                              alt={full_name}
                              sx={{ width: "100%", height: "100%" }}
                            />
                          </Box>
                          <Box className="artistNameText" component={"h3"}>
                            {full_name}
                          </Box>
                          <Typography sx={{ marginBottom: "5px" }}>
                            Role: {roles || "NA"}
                          </Typography>
                          <Typography sx={{ marginBottom: "20px" }}>
                            Location: {locations || "NA"}
                          </Typography>
                          <Box className="catalogueCardButtons">
                            <Button
                              className="catalogueCardProfileButton"
                              data-test-id="profile-button"
                              onClick={() =>
                                this.handleProfileRedirect(userDetails)
                              }
                            >
                              {configJSON.profileText}
                            </Button>
                            <Button
                              className="catalogueCardMessageButton"
                              data-test-id="chat-button"
                              onClick={() => this.handleChatRedirect(id)}
                            >
                              {configJSON.messageText}
                            </Button>
                          </Box>
                        </Box>
                      );
                    })}
                  </Box>
                  <Pagination
                    data-test-id="pagination"
                    variant="outlined"
                    shape="rounded"
                    className="customPagination"
                    page={this.state.page + 1}
                    count={this.state.totalPages}
                    onChange={(_event: unknown, newPage: number) => {
                      this.onChangeHandler(newPage - 1);
                    }}
                    siblingCount={0}
                    boundaryCount={1}
                    renderItem={(item) => (
                      <PaginationItem
                        {...item}
                        sx={{
                          fontSize: "13px",
                          fontWeight: "600 !important",
                          lineHeight: "15.85px",
                          color: item.selected ? "white" : "#0F172A",
                          backgroundColor: item.selected
                            ? "#652784 !important"
                            : "#fff !important",
                          border: "0.8px solid #CBD5E1",
                          borderRadius: "8px",
                          "&:hover": {
                            backgroundColor: "#652784 !important",
                            color: "white !important",
                          },
                          "@media (max-width: 414px)": {
                            fontSize: "10px",
                            lineHeight: "12px",
                          },
                          "@media (min-width: 415px) and (max-width: 1280px)": {
                            fontSize: "12px",
                            lineHeight: "14px",
                          },
                          "@media (min-width: 1600px)": {
                            fontSize: "15px",
                            lineHeight: "17px",
                          },
                        }}
                        components={{
                          previous: () => (
                            <Box
                              data-test-id="prevButton"
                              component={"div"}
                              className="paginationNavButtons"
                            >
                              Prev
                            </Box>
                          ),
                          next: () => (
                            <Box
                              data-test-id="nextButton"
                              component={"div"}
                              className="paginationNavButtons"
                            >
                              Next
                            </Box>
                          ),
                        }}
                      />
                    )}
                  />
                </>
              ) : (
                <ConditionalRenderer isVisible={!this.state.isLoading}>
                  <Box p="20px" height="400px">
                    <EmptyResultTitle data-test-id="empty-result-message">
                      {configJSON.emptyResultTitleText}
                    </EmptyResultTitle>
                    <EmptyResultSubTitle>
                      {configJSON.emptyResultSubTitleText}
                    </EmptyResultSubTitle>
                  </Box>
                </ConditionalRenderer>
              )}
            </Box>
            <GoogleAd
              responsive
              format="auto"
              sx={{ mt: 6 }}
              slot="3885795370"
            />
          </BannerWithContent>
          <AppFooter navigation={this.props.navigation} />
        </TypographyView>
      </>
      // Customizable Area End
      //Merge Engine End DefaultContainer
    );
  }
}

// Customizable Area Start
// Customizable Area End
